
import React from "react";

export const Part1DataSource = {
    wrapper: { className: ' surgical-part1-wrapper' },
    page: { className: 'surgical-part1' },
    OverPack: { playScale: 0.3, className: '' },
    childWrapper: {
      className: 'title-wrapper',
      children: [
        {
          name: 'title',
          children: 'CanHealthy',
          className: 'title-h1',
        },
        {
          name: 'title',
          children: 'AI Vision-Based Surgical Inventory System',
          className: 'title-h2',
        },
        {
          name: 'content',
          className: 'title-content surgical-part1-title-content',
          children: '基于视觉AI的手术工具清点系列',
        },
      ],
    },
    video: {
      className: 'surgical-part1-video',
      children: {
        video: process.env.SOURCE_URL+'/PL01A-OT01A.mp4',
        image: process.env.SOURCE_URL+'/solarpv-1.png',
      },
    },
    image: {
      className: 'surgical-part1-image',
      children:
      process.env.SOURCE_URL+'/surgicaltool-part1.png',
    },
  
}

export const Part2DataSource = {
  wrapper: { className: 'surgical-part2-wrapper'},
  page: { className: 'surgical-part2 part2-page' },
  content:{
    className:'surgical-part2-content',
    children: (
      <div>
        <h3>分类算法+分类算法</h3>
        <h1>基于深度学习｜专为骨科手术工具定制</h1>
      </div>
    ),
  },
}

export const Part3DataSource = {
  wrapper: { className: 'home-page-wrapper surgical-part3-wrapper'},
  page: { className: 'home-page surgical-part3' },
  OverPack: { playScale: 0.3, className: '' },
  content:{
    className:'part2-content',
    children: (
      <div>
        <h1>速度快，又不失精度</h1>
        <h3>视觉AI算法 | 模型持续升级 | 自训练平台</h3>
      </div>
    ),
  },

  image: {
    className: 'surgical-part3-image',
    children:
    process.env.SOURCE_URL+'/surgicaltool-part3.png',
  },
  label:[
    {
      name:'title',
      className:'surgical-part3-label',
      children:''
    }
  ]
}


export const Part4DataSource = {
  wrapper: { className: 'home-page-wrapper surgical-part3-wrapper'},
  page: { className: 'home-page surgical-part3' },
  OverPack: { playScale: 0.3, className: '' },
  content:{
    className:'part2-content',
    children: (
      <div>
        <h1>适用于不同包装与材质器械</h1>
        <h3></h3>
      </div>
    ),
  },

  image: {
    className: 'surgical-part3-image',
    children:
    process.env.SOURCE_URL+'/surgicaltool-part6.png',
  },
  label:[
    {
      name:'title',
      className:'surgical-part3-label',
      children:''
    }
  ]
}



export const Part5DataSource = {
  wrapper: { className: 'home-page-wrapper surgical-part5-wrapper' },
  page: { className: 'home-page surgical-part5' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: '减少人员依赖 | 规范清点行为 | 溯源清点过程',
        className: 'title-h1',
      },
      {
        name: 'content',
        className: 'title-content',
        children: '',
      },
    ],
  },
  block: {
    className: 'surgical-part5-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'surgical-part5-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'surgical-part5-icon',
            children:
            process.env.SOURCE_URL+'/pv/icon/1.png',
          },
          textWrapper: { className: 'surgical-part5-text' },
          title: { className: 'surgical-part5-title', children: '数据筛选与清洗' },
          content: {
            className: 'surgical-part5-content',
            children:
              '统计分类照片类别，细致专业，不浪费素材',
          },
        },
      },
      {
        name: 'block1',
        className: 'surgical-part5-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'surgical-part5-icon',
            children:
            process.env.SOURCE_URL+'/pv/icon/2.png',
            
          },
          textWrapper: { className: 'surgical-part5-text' },
          title: { className: 'surgical-part5-title', children: '数据标记' },
          content: {
            className: 'surgical-part5-content',
            children:
              '专业可明数字化标记软件，供算法训练',
          },
        },
      },
      {
        name: 'block2',
        className: 'surgical-part5-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'surgical-part5-icon',
            children:
            process.env.SOURCE_URL+'/pv/icon/3.png',
            
          },
          textWrapper: { className: 'surgical-part5-text' },
          title: { className: 'surgical-part5-title', children: '模型开发与迭代' },
          content: {
            className: 'surgical-part5-content',
            children:
              '自研算法模型，持续更新进步，不失效率',
          },
        },
      },
      {
        name: 'block3',
        className: 'surgical-part5-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'surgical-part5-icon',
            children:
            process.env.SOURCE_URL+'/pv/icon/4.png',
          },
          textWrapper: { className: 'surgical-part5-text' },
          title: { className: 'surgical-part5-title', children: '应用软件定制开发' },
          content: {
            className: 'surgical-part5-content',
            children:
              '按需求定制开发软件，保证模型的调用效率',
          },
        },
      },
      {
        name: 'block4',
        className: 'surgical-part5-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'surgical-part5-icon',
            children:  process.env.SOURCE_URL+'/pv/icon/5.png',

          },
          textWrapper: { className: 'surgical-part5-text' },
          title: { className: 'surgical-part5-title', children: '缺陷结果校验' },
          content: {
            className: 'surgical-part5-content',
            children:
              '按不同的质检要求灵活调整算法模型',
          },
        },
      },
      {
        name: 'block5',
        className: 'surgical-part5-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'surgical-part5-icon',
            children:  process.env.SOURCE_URL+'/pv/icon/6.png',

          },
          textWrapper: { className: 'surgical-part5-text' },
          title: { className: 'surgical-part5-title', children: '数据分析' },
          content: {
            className: 'surgical-part5-content',
            children:
              '按质检要求与研究方向分析数据，提供报表',
          },
        },
      },
    ],
  },
};



export const Part6DataSource = {
  wrapper: { className: ' surgical-part6-wrapper' },
  page: { className: 'surgical-part6' },
  OverPack: { playScale: 0.3, className: '' },
  childWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: '我们的特色：AI + 集成',
        className: 'title-h1',
      },
      {
        name: 'content',
        className: 'title-h1',
        children: '专属定制',
      },
    ],
  },
  image: {
    className: 'surgical-part6-image',
    children:
    process.env.SOURCE_URL+'/solarpv-1.png',
  },

};


  export const Part10DataSource = {
    wrapper: {
      className: 'case-wrapper-comp-wrapper',
    },
    page: {
      className: 'case-wrapper-comp',
    },
    OverPack: {
      playScale: 0.3,
      className: '',
    },
    titleWrapper: {
      className: 'title-wrapper',
      children: [
        {
          name: 'title',
          children: 'CanEnergy系列更多产品',
        },
      ],
    },
    block: {
      className: 'block-wrapper',
      children: [
        {
          name: 'block0',
          className: 'block',
          md: 8,
          href:'/nuclear',
          xs: 24,
          titleWrapper: {
            children: [
              {
                name: 'image',
                className: 'case-wrapper-comp-image',
                children: process.env.SOURCE_URL+'/energy-1.png',
              },
              {
                name: 'title',
                className: 'case-wrapper-comp-title',
                children: '核电运维AI解决方案',
              },
            ],
          },
        },
        {
          name: 'block1',
          className: 'block',
          md: 8,
          xs: 24,
          href:'#',
          titleWrapper: {
            children: [
              {
                name: 'image',
                className: 'case-wrapper-comp-image',
                children: process.env.SOURCE_URL+'/energy-3.png',
  
              },
              {
                name: 'title',
                className: 'case-wrapper-comp-title',
                children: '新能源电池包质检',
              },
            ],
          },
        },
        // {
        //   name: 'block2',
        //   className: 'block',
        //   md: 8,
        //   xs: 24,
        //   titleWrapper: {
        //     children: [
        //       {
        //         name: 'title',
        //         className: 'case-wrapper-comp-title title-1',
        //         children: '持续推出',
        //       },
        //     ],
        //   },
        // },
      ],
    },
  }


  export const PriceDataSource = {
    wrapper: { className: 'home-page-wrapper security-part8-wrapper' },
    page: { className: 'home-page security-part8' },
    OverPack: { playScale: 0.3, className: 'security-part8-content-wrapper' },
    titleWrapper: {
      className: 'security-part8-title-wrapper',
      children: [
        { name: 'title', children: '多种订阅方式', className: 'security-part8-title-h1' },
      ],
    },
    Table: {
      name: 'tabsTitle',
      size: 'default',
      className: 'security-part8-table',
      columns: {
        children: [
          {
            dataIndex: 'free',
            key: 'free',
            name: 'free',
            childWrapper: {
              className: 'security-part8-table-name-block',
              children: [
                {
                  name: 'name',
                  className: 'security-part8-table-name',
                  children: '永久授权',
                },
              ],
            },
          },
          {
            dataIndex: 'basic',
            key: 'basic',
            name: 'basic',
            childWrapper: {
              className: 'security-part8-table-name-block',
              children: [
                {
                  name: 'name',
                  className: 'security-part8-table-name',
                  children: '订阅授权',
                },
              ],
            },
          },
          {
            dataIndex: 'pro',
            key: 'pro',
            name: 'pro',
            childWrapper: {
              className: 'security-part8-table-name-block',
              children: [
                {
                  name: 'name',
                  className: 'security-part8-table-name',
                  children: '质检包授权',
                },
              ],
            },
          },
          {
            dataIndex: 'unlimited',
            key: 'unlimited',
            name: 'unlimited',
            childWrapper: {
              className: 'security-part8-table-name-block',
              children: [
                {
                  name: 'name',
                  className: 'security-part8-table-name',
                  children: '定制开发',
                },
              ],
            },
          },
        ],
      },
      dataSource: {
        children: [
          {
            name: 'list0',
            children: [
              {
                children: '一次性建设',
                name: 'content0',
                className: 'security-part8-table-content',
              },
              {
                children: '按年采用订阅的方式',
                name: 'content1',
                className: 'security-part8-table-content',
              },
              {
                children: '质检包授权',
                name: 'content2',
                className: 'security-part8-table-content',
              },
              {
                children: '定制开发',
                name: 'security-part3',
                className: 'security-part8-table-content',
              },
            ],
          },
        ],
      },
    },
  };
  